import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Card, Col, Form, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const GroupCreate = () => {
  const navigate = useNavigate();
  const [groupname, setgroupname] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Har word ka first letter capital karne ka function (Title Case)
  const capitalizeAllWords = (text) => {
    if (!text) return text;
    
    return text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    const capitalizedValue = capitalizeAllWords(value);
    setgroupname(capitalizedValue);
  };

  const validateForm = () => {
    if (!groupname) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Form',
        text: 'Please enter a group name.',
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsLoading(true);

    const groupData = {
      groupname: groupname,
    };

    try {
      const response = await axios.post(BASE_URL + "productGroup/save", groupData, {
        headers: authHeader(),
      });
      console.log('group', response.data);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Group added successfully!',
      });
      navigate("/groupindex/1");
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response.data,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD GROUP</h6>
          <Link to="/groupindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group controlId="formgroupname">
                  <Form.Label>Group Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Group name"
                    value={groupname}
                    onChange={handleInputChange} // Yahan change kiya hai
                  />
                </Form.Group>
              </Col>
            </Row>
            <button className="button-70" type="button" onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? <Spinner animation="border" size="sm" /> : 'SUBMIT'}
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default GroupCreate;